import {
  LEAD_MARKETING2_REPORT1_REQUEST,
  LEAD_MARKETING2_REPORT1_SUCCESS,
  LEAD_MARKETING2_REPORT1_FAIL,
  LEAD_MARKETING2_REPORT2_FAIL,
  LEAD_MARKETING2_REPORT2_REQUEST,
  LEAD_MARKETING2_REPORT2_SUCCESS,
  LEAD_MARKETING2_REPORT3_FAIL,
  LEAD_MARKETING2_REPORT3_REQUEST,
  LEAD_MARKETING2_REPORT3_SUCCESS,
  LEAD_MARKETING2_REPORT4_REQUEST,
  LEAD_MARKETING2_REPORT4_FAIL,
  LEAD_MARKETING2_REPORT4_SUCCESS,
  LEAD_MARKETING2_REPORT5_REQUEST,
  LEAD_MARKETING2_REPORT5_FAIL,
  LEAD_MARKETING2_REPORT5_SUCCESS,
} from "../constant/LeadMarketing2Constant";
import api from "../core/api";

export const getLMReport1 = (reportJson) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LEAD_MARKETING2_REPORT1_REQUEST,
    });

    const { data } = await api.post(
      `/api/report/LeadMarketing4/rec1`,
      reportJson,
    );

    const res = data.Result;
    if (typeof res === "string") {
      dispatch({
        type: LEAD_MARKETING2_REPORT1_FAIL,
        payload: res,
      });
    } else {
      dispatch({
        type: LEAD_MARKETING2_REPORT1_SUCCESS,
        payload: res[0],
      });
    }
  } catch (ex) {
    dispatch({
      type: LEAD_MARKETING2_REPORT1_FAIL,
      payload: "Error - " + ex.message,
    });
  }
};

export const getLMReport2 = (reportJson) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LEAD_MARKETING2_REPORT2_REQUEST,
    });

    const { data } = await api.post(
      `/api/report/LeadMarketing4/rec2`,
      reportJson,
    );

    const res = data.Result;
    if (typeof res === "string") {
      dispatch({
        type: LEAD_MARKETING2_REPORT2_FAIL,
        payload: res,
      });
    } else {
      dispatch({
        type: LEAD_MARKETING2_REPORT2_SUCCESS,
        payload: res[0],
      });
    }
  } catch (ex) {
    dispatch({
      type: LEAD_MARKETING2_REPORT2_FAIL,
      payload: "Error - " + ex.message,
    });
  }
};

export const getLMReport3 = (reportJson) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LEAD_MARKETING2_REPORT3_REQUEST,
    });

    const { data } = await api.post(
      `/api/report/LeadMarketing4/rec3`,
      reportJson,
    );

    const res = data.Result;
    if (typeof res === "string") {
      dispatch({
        type: LEAD_MARKETING2_REPORT3_FAIL,
        payload: res,
      });
    } else {
      dispatch({
        type: LEAD_MARKETING2_REPORT3_SUCCESS,
        payload: res[0],
      });
    }
  } catch (ex) {
    dispatch({
      type: LEAD_MARKETING2_REPORT3_FAIL,
      payload: "Error - " + ex.message,
    });
  }
};

export const getLMReport4 = (reportJson) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LEAD_MARKETING2_REPORT4_REQUEST,
    });

    const { data } = await api.post(
      `/api/report/LeadMarketing4/rec4`,
      reportJson,
    );

    const res = data.Result;
    if (typeof res === "string") {
      dispatch({
        type: LEAD_MARKETING2_REPORT4_FAIL,
        payload: res,
      });
    } else {
      dispatch({
        type: LEAD_MARKETING2_REPORT4_SUCCESS,
        payload: res,
      });
    }
  } catch (ex) {
    dispatch({
      type: LEAD_MARKETING2_REPORT4_FAIL,
      payload: "Error - " + ex.message,
    });
  }
};

export const getLMReport5 = (reportJson) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LEAD_MARKETING2_REPORT5_REQUEST,
    });

    const { data } = await api.post(
      `/api/report/LeadMarketing4/rec5`,
      reportJson,
    );

    const res = data.Result;
    if (typeof res === "string") {
      dispatch({
        type: LEAD_MARKETING2_REPORT5_FAIL,
        payload: res,
      });
    } else {
      dispatch({
        type: LEAD_MARKETING2_REPORT5_SUCCESS,
        payload: res,
      });
    }
  } catch (ex) {
    dispatch({
      type: LEAD_MARKETING2_REPORT5_FAIL,
      payload: "Error - " + ex.message,
    });
  }
};
